const wrapperCSS = ({ theme }) => ({
  maxHeight: '80vh',
  overflow: 'auto',
  margin: `-${theme['default-spacer-sm']}`,
  padding: theme['default-spacer-sm'],
})

export default wrapperCSS
